export default "__VITE_ASSET__BaAfs1Pg__"